if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      console.log('[ATC-DEBUG] ProductForm constructor called');
      this.form = this.querySelector('form');
      if (!this.form) {
        console.log('[ATC-DEBUG] No form found in product-form element');
        return;
      }
      console.log('[ATC-DEBUG] Form found:', this.form.id);
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) {
        idInput.disabled = false;
        console.log('[ATC-DEBUG] Variant ID input:', idInput.value);
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
      console.log('[ATC-DEBUG] ProductForm initialized successfully');
    }

    onSubmitHandler(evt) {
      console.log('[ATC-DEBUG] ========== ADD TO CART STARTED ==========');
      evt.preventDefault();
      evt.stopPropagation();
      
      // Find cart drawer at submit time to ensure it exists
      this.cart = document.querySelector('cart-drawer');
      console.log('[ATC-DEBUG] Cart drawer found:', !!this.cart);
      
      if (!this.submitButton) this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && this.submitButton.getAttribute('disabled') === 'true') {
        console.log('[ATC-DEBUG] Submit button is disabled, aborting');
        return;
      }
      
      this.handleErrorMessage();
      if (this.submitButton) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');
        const addToCartText = this.submitButton.querySelector('[data-add-to-cart-text]');
        if (addToCartText) addToCartText.classList.add('hidden');
      }
      this.querySelector('.loading--spinner')?.classList.remove('hidden');
      
      console.log('[ATC-DEBUG] Checking fetchConfig function:', typeof fetchConfig);
      if (typeof fetchConfig !== 'function') {
        console.error('[ATC-DEBUG] ERROR: fetchConfig is not defined!');
        return;
      }
      
      const config = fetchConfig('javascript');
      console.log('[ATC-DEBUG] Config created:', JSON.stringify(config));
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(this.form);
      console.log('[ATC-DEBUG] FormData variant ID:', formData.get('id'));
      console.log('[ATC-DEBUG] FormData quantity:', formData.get('quantity') || '1 (default)');
      
      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        console.log('[ATC-DEBUG] Sections to render:', sections);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
      
      console.log('[ATC-DEBUG] Fetching:', routes.cart_add_url);
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          console.log('[ATC-DEBUG] Raw response status:', response.status);
          console.log('[ATC-DEBUG] Response ok:', response.ok);
          return response.json();
        })
        .then((response) => {
          console.log('[ATC-DEBUG] Parsed response:', JSON.stringify(response).substring(0, 500));
          
          if (response.status) {
            console.log('[ATC-DEBUG] ERROR from Shopify:', response.status, response.message, response.description);
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('disabled', true);
            this.error = true;
             const drawerSelector = document.querySelector("#quickView-drawer");
             setTimeout(() => {
              //focusElement = event.target;
              trapFocusElements(drawerSelector);
          }, 500);
            return;
          } else if (!this.cart) {
            console.log('[ATC-DEBUG] No cart drawer, redirecting to cart page');
            window.location = window.routes.cart_url;
            return;
          }
          
          console.log('[ATC-DEBUG] SUCCESS - Item added to cart');
          console.log('[ATC-DEBUG] Product:', response.product_title);
          console.log('[ATC-DEBUG] Variant:', response.variant_id);
          console.log('[ATC-DEBUG] Quantity:', response.quantity);
          
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          // Meta Pixel — AddToCart. Fires on every successful add (PDP, quick view, product cards).
          // Guarded: no-op if the Meta Pixel base code (window.fbq) isn't present on the page.
          try {
            var variantId = response.variant_id || response.id || formData.get('id');
            var quantity = Number(response.quantity) || Number(formData.get('quantity')) || 1;
            // Shopify prices are in cents; Meta wants major units (e.g. dollars).
            var unitCents = Number(response.final_price != null ? response.final_price : response.price);
            var price = isNaN(unitCents) ? 0 : unitCents / 100;
            var currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || response.currency || 'USD';

            if (typeof window.fbq === 'function') {
              fbq('track', 'AddToCart', {
                content_ids: [variantId],
                content_type: 'product',
                contents: [
                  {
                    id: variantId,
                    quantity: quantity,
                    item_price: Number(price)
                  }
                ],
                value: Number(price) * quantity,
                currency: currencyCode
              });
              console.log('[ATC-DEBUG] Meta Pixel AddToCart FIRED', { variantId: variantId, quantity: quantity, price: price, currency: currencyCode });
            } else {
              console.warn('[ATC-DEBUG] Meta Pixel AddToCart NOT fired — window.fbq is not defined on this page.');
            }
          } catch (fbErr) {
            console.error('[ATC-DEBUG] Meta Pixel AddToCart error', fbErr);
          }
          if(this.cart){
            console.log('[ATC-DEBUG] Rendering cart drawer contents');
            if(document.querySelector(".product-sticky-bar")){
              document.querySelector(".product-sticky-bar").classList.remove("is-visible")
            }
            this.cart.renderContents(response);
            this.cart.classList.add("is-visible");
            focusElement = this.submitButton;
            document.querySelector("body").classList.add("overflow-hidden");
            console.log('[ATC-DEBUG] Cart drawer should now be visible');
          }
        })
        .catch((e) => {
          console.error('[ATC-DEBUG] FETCH ERROR:', e);
        })
        .finally(() => {
          console.log('[ATC-DEBUG] ========== ADD TO CART FINISHED ==========');
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            const addToCartText = this.submitButton.querySelector('[data-add-to-cart-text]');
            if (addToCartText) addToCartText.classList.remove('hidden');
            if (!this.error) this.submitButton.removeAttribute('disabled');
          }
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');
          this.querySelector('.loading--spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form--error-message-wrapper') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form--error-message') || this.closest("product-card").querySelector('.product-form--error-message-wrapper');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}